/**
 * Fautes d'équipe typables — un seul inventaire.
 *
 * Le menu rapide de la barre de saisie n'en proposait que trois (filet, mordu,
 * double touche) quand le modal détaillé en proposait cinq. Un coach qui voulait
 * noter un porté devait donc savoir que ce geste existe ailleurs : le même fait
 * de jeu était saisissable ou non selon l'écran.
 *
 * Les valeurs sont celles qui partent en base et dans les exports — elles ne
 * bougent pas. Les libellés viennent de `getActionName` (`game.actions`), la
 * table qui nomme déjà toutes les actions : le modal en avait une seconde, dont
 * deux entrées retombaient sur du français en dur.
 */
export const TEAM_FAULT_ACTIONS = [
  'Faute de Fil',
  'Mordu',
  'Double Touches',
  'Porté',
  'Quatre Touches',
  // Also covers the rotation fault (wrong server, VOL-339): same outcome.
  'Faute de Position',
] as const;

export type TeamFaultAction = (typeof TEAM_FAULT_ACTIONS)[number];

/**
 * Called on a team, often before any touch and without knowing who is out of
 * place: the capture asks for the faulting team and never requires a player.
 */
export const POSITION_FAULT_ACTION: TeamFaultAction = 'Faute de Position';
